// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryPharmacyPayor {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryPharmacyPayor.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryPharmacyPayor.discriminator = undefined;
MangoHubGetPatientSummaryPharmacyPayor.additionalProperties = false;
MangoHubGetPatientSummaryPharmacyPayor.attributeTypeMap = [
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "group",
        "baseName": "group",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "planTypeDescription",
        "baseName": "planTypeDescription",
        "type": "string"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
];
//# sourceMappingURL=mangoHubGetPatientSummaryPharmacyPayor.js.map